'use strict';

import angular from 'angular';
import confirmPopup from '../popup/confirm-popup/confirm-popup.controller';
import alertPopup from '../popup/alert-popup/alert-popup.controller';

export default angular.module('ngOskCrmApp.service', [confirmPopup, alertPopup])
  .factory('pageSettings', () => {
    let exports = {
      setTitle: title => {
        exports.settings.title = title;
      },
      setState: (state, stateParams) => {
        exports.settings.state = state;
        exports.settings.stateParams = stateParams || {};
      },
      setTheme: theme => {
        exports.theme = theme || 'default';
      },
      settings: {
        title: null,
        state: null,
        stateParams: {},
        theme: 'default'
      }
    };
    return exports;
  })
  .factory('LeftNav', () => {
    var exports = {
      setActive: function (slug, state) {
        this.selected.slug = slug;
        this.selected.state = state;
      },
      selected: {}
    };
    return exports;
  })
  .factory('helper', ['$mdToast', '$mdDialog', '$translate', '$window', ($mdToast, $mdDialog, $translate, $window) => {
    const exports = {
      windowOpen: url => {
        let myNewTab = exports.openNewTab();
        exports.updateTabLocation(url, myNewTab);
      },
      openNewTab: function(){
        let newTabWindow = $window.open();
        return newTabWindow;
      },
      updateTabLocation: (tabLocation, tab) => {
        if(!tabLocation){
          tab.close();
        }
        tab.location.href = tabLocation;
      },
      getUTCDate: date => {
        if (!_.isDate(date)) {
          date = new Date(date);
        }
        return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),  date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
      },
      paddy: (n, p, c) => {
        let pad_char = typeof c !== 'undefined' ? c : '0';
        let pad = new Array(1 + p).join(pad_char);
        return (pad + n).slice(-pad.length);
      },
      confirm: function (title, text, yesText, noText) {
        let confirm = $mdDialog.show({
          template: require('../popup/confirm-popup/confirm-popup.pug'),
          controller: 'confirmPopupController',
          controllerAs: 'vm',
          resolve: {
            title: function () {
              return title;
            },
            message: function () {
              return text;
            },
            yesText: function () {
              return yesText;
            },
            noText: function () {
              return noText;
            }
          }
        });

        return confirm;
      },
      alert: (title, text) => {
        return $mdDialog.show({
          template: require('../popup/alert-popup/alert-popup.pug'),
          controller: 'alertPopupController',
          controllerAs: 'vm',
          resolve: {
            title: function () {
              return title;
            },
            message: function () {
              return text;
            }
          }
        });
      },
      getDateDiff: (dateFrom, dateTo, monthTreshold) => {
        // TODO: Check if proper
        const _MS_PER_DAY = 1000 * 60 * 60 * 24;
        let dateFromMonth = dateFrom.getMonth();
        let dateFromYear = dateFrom.getFullYear();
        let dateDiffMonth = dateFromMonth + monthTreshold;
        if (dateDiffMonth > 12) {
          dateDiffMonth = 12 - dateDiffMonth;
          dateFromYear = dateFromYear + 1;
        }
        let utc1 = Date.UTC(dateFromYear, dateDiffMonth, dateFrom.getDate());
        let utc2 = Date.UTC(dateTo.getFullYear(), dateTo.getMonth(), dateTo.getDate());
        // TODO: Implement leap year
        return Math.floor((utc1 - utc2) / _MS_PER_DAY);
      },
      translate: key => $translate(key),
      showOperationSuccessToast: () => {
        const toast = $mdToast.simple()
          .textContent('Dane zapisane')
          .action('Zamknij')
          .highlightAction(true)
          .position('right top')
          .theme('greenTheme')
          .highlightClass('md-primary')
          .hideDelay(13000)
          .toastClass('success');

        $mdToast.show(toast).then(function (response) {

        });
      },
      showOperationFailedToast: () => {
        const toast = $mdToast.simple()
          .textContent('Wystąpił błąd, dane się nie zapisały')
          .action('Zamknij')
          .highlightAction(true)
          .position('right top')
          .highlightClass('md-warn')
          .hideDelay(13000)
          .toastClass('failed');

        $mdToast.show(toast).then(function (response) {

        });
      },
      convertToDateTime: (data) => {
        return new Date(data);
      }
    };

    return exports;
  }])
  .name;





// WEBPACK FOOTER //
// ./client/app/shared/service/index.js